<div class="row">
  <div class="col-sm-12 col-md-auto" *ngIf="media && isLogo">
    <img src="{{ media.Url }}" title="{{ media.Nom }}" class="img-upload" [style.maxHeight]="maxHeight" [style.maxWidth]="maxWidth" />
    <!--(click)="displayZoom = !displayZoom"-->
  </div>
  <div class="col-sm-12 col-md-auto" *ngIf="media && !isLogo">
    <a [href]="media.Url" [download]="media.Nom">
      {{ media.Nom }}
    </a>
  </div>
  <div class="col-sm-12 col-md-auto" *ngIf="editMode">
    <div class="row">
      <div class="col-sm-12 col-md-auto">
        <input type="file" #file placeholder="Sélectionner un fichier" (change)="uploadFile(file.files)" style="display: none" accept="{{ accept }}" />
        <button type="button" class="btn btn-sm btn-primary btn-space-right" (click)="file.click()" style="width: 100%"><i class="fa fa-upload" aria-hidden="true"></i> {{ texteAjout }}</button
        ><br />
        <button type="button" class="btn btn-sm btn-danger btn-space-right" (click)="deleteFile()" *ngIf="media" style="margin-top: 3px; margin-bottom: 3px; width: 100%"><i class="fa fa-trash" aria-hidden="true"></i> {{ texteSuppression }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-auto">
        <span *ngIf="texteAideFormat" class="text-aide text-success"><i class="fa fa-info-circle" aria-hidden="true"></i> {{ texteAideFormat }}<br /></span>
        <span *ngIf="texteAvertissement" class="text-avertissement text-warning"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ texteAvertissement }}</span>
      </div>
    </div>
  </div>
</div>
<!--<p-dialog header="Zoom" [(visible)]="displayZoom" [modal]="true" [style]="{width: '95vw'}" [draggable]="false" [resizable]="false" [dismissableMask]="true" *ngIf="media && isLogo">
  <img src="{{media.Url}}" title="{{media.Nom}}" style="max-width: 92vw; max-height: 70vh;" (click)="displayZoom = !displayZoom" />
</p-dialog>-->
